import type { ReactNode } from 'react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { AritoIcon } from '@/components/custom/arito/icon';
import { cn } from '@/lib/utils';

interface AritoIconActionButtonProps {
  title: string;
  icon: number;
  onClick?: () => void;
  disabled?: boolean;
  size?: 'small' | 'large';
  className?: string;
  iconClassName?: string;
}

export function AritoIconActionButton({
  title,
  icon,
  onClick,
  disabled,
  size = 'small',
  className,
  iconClassName
}: AritoIconActionButtonProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span>
            <button
              type='button'
              onClick={onClick}
              disabled={disabled}
              className={cn(
                'flex cursor-default items-center justify-center rounded-none border border-transparent p-0 text-white hover:border-[#abd3ef] hover:bg-[rgba(25,118,210,0.15)] hover:text-[#007acc] disabled:text-black/25 disabled:hover:border-[#abd3ef] disabled:hover:bg-[rgba(25,118,210,0.15)] disabled:hover:text-black/25',
                size === 'large' ? 'size-10 min-w-10' : 'size-6 min-w-6',
                className
              )}
            >
              <AritoIcon icon={icon} className={iconClassName} />
            </button>
          </span>
        </TooltipTrigger>
        <TooltipContent>{title}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

interface AritoLabelActionButtonProps {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export function AritoLabelActionButton({ children, onClick, disabled, className }: AritoLabelActionButtonProps) {
  return (
    <button
      type='button'
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'flex h-6 min-w-0 items-center gap-1 rounded-none border border-transparent px-2 py-1 text-xs normal-case text-white transition-colors hover:border-[#abd3ef] hover:bg-[rgba(25,118,210,0.15)] hover:text-[#007acc] disabled:cursor-default disabled:text-black/25',
        className
      )}
    >
      {children}
    </button>
  );
}
